import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WidgetDirective } from './widget.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [WidgetDirective],
    exports: [WidgetDirective]
})
export class WidgetModule {}
